import React, { useEffect, useState } from "react";
import { Holiday } from "../types/Holiday";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../styles/Form.css";

interface Props {
  onSave: (holiday: Holiday) => void;
  initialData?: Holiday | null;
  clearAfterSubmit: () => void;
}

const initialState: Holiday = {
  id: 0,
  day: "",
  month: "",
  year: "",
  reason: "",
};

const HolidayForm: React.FC<Props> = ({
  onSave,
  initialData,
  clearAfterSubmit,
}) => {
  const [holiday, setHoliday] = useState<Holiday>(initialState);

  useEffect(() => {
    if (initialData) {
      setHoliday(initialData);
    }
  }, [initialData]);

  type FormElement =
  | HTMLInputElement
  | HTMLSelectElement
  | HTMLTextAreaElement;

const handleChange = (e: React.ChangeEvent<FormElement>) => {
  const { name, value } = e.target;
  setHoliday((prev) => ({ ...prev, [name]: value }));
};
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(holiday);
    setHoliday(initialState);
    clearAfterSubmit();
  };

  const handleClear = () => {
    setHoliday(initialState);
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group>
              <Form.Label>Day</Form.Label>
              <Form.Select
                name="day"
                className="custom-select"
                value={holiday.day}
                onChange={handleChange}
                required
              >
                <option value="">Select Day</option>
                {Array.from({ length: 31 }, (_, i) => (
                  <option key={i + 1} value={String(i + 1)}>
                    {i + 1}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group>
              <Form.Label>Month</Form.Label>
              <Form.Select
                name="month"
                className="custom-select"
                value={holiday.month}
                onChange={handleChange}
                required
              >
                <option value="">Select Month</option>
                {[
                  "January",
                  "Febuary",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group>
              <Form.Label>Year</Form.Label>
              <Form.Select
                name="year"
                className="custom-select"
                value={holiday.year}
                onChange={handleChange}
                required
              >
                <option value="">Select Year</option>
                {Array.from({ length: 10 }, (_, i) => {
                  const year = new Date().getFullYear() - i;
                  return (
                    <option key={year} value={String(year)}>
                      {year}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group>
              <Form.Label>Reason</Form.Label>
              <Form.Control
                name="reason"
                value={holiday.reason}
                onChange={handleChange}
                placeholder="reason"
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-1">
          <Col md={12}>
            <div className="form-buttons">
              <Button type="submit" className="btn-save">
                {initialData?.id ? "Update" : "Save"}
              </Button>
              <Button type="button" className="btn-clear" onClick={handleClear}>
                Clear All
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default HolidayForm;
